import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardAppUser from "../../../assets/img/backgrounds/login_carousel_2-min.jpg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import SegmentUtils from "../../../lib/SegmentUtils";

const ProgressTrackingIntroPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(
    Capacitor?.isNativePlatform() ? true : false,
  );
  const pageRef = useRef();

  const [user, setUser] = useState<any>(null);

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    StorageUtils.get("user_customer").then((user) => {
      setUser(user);
    });
  }, []);

  const logout = async () => {
    await StorageUtils.clear();

    SegmentUtils.track("User Signout");

    const win: any = window;

    if (win?.posthog) {
      win?.posthog.reset();
    }

    if (nativeMode) {
      window.location.href = "/login";

      return;
    }

    if (Capacitor.isNativePlatform()) {
      OneSignal.logout();
    }

    history.push("/login");
  };

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : (
                <IonButtons slot="start">
                  <IonButton
                    color="dark"
                    onClick={() => {
                      logout();
                    }}
                    mode={
                      Capacitor.isNativePlatform()
                        ? Capacitor.getPlatform() == "ios"
                          ? "ios"
                          : "md"
                        : "ios"
                    }
                  >
                    Sign Out
                  </IonButton>
                </IonButtons>
              )}
              <IonTitle>Welcome To PLN</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={
            <>
              <IonButton
                fill="clear"
                className="pln-navbar-button ml-0"
                color="dark"
                expand="block"
                onClick={() => {
                  logout();
                }}
              >
                Logout
              </IonButton>
            </>
          }
          showMenuButton={false}
          pageName={"Welcome To PLN"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding pln-onboarding-container">
          <div className="text-center">
            <div className="rounded w-full min-h-[300px] max-h-[300px] max-w-[500px] mx-auto sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
              <img
                src={onboardAppUser}
                alt="App User"
                className="w-full shadow border h-full mx-auto max-h-[300px] rounded-2xl sm:max-h-[350px] object-cover"
              />
            </div>

            <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.5rem]">
              Track Your Progress. Crush Your Goals.
            </h2>

            <p className="max-w-[700px] mx-auto" style={{ fontSize: 18 }}>
              Everything you need to monitor your body, log your meals, and stay
              on track — all in one app powered by real people, smart
              technology, and your personal data.
            </p>

            <div className="py-4">
              <div className="text-center text-2xl font-medium font-[SourceSerif]">
                Your Complete Tracking Toolkit:
              </div>
              <div className="my-4 text-center p-3 border rounded-lg max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Apple Health & Google Health Sync</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Connect your health apps to automatically sync steps,
                  workouts, heart rate, and more — so all your data lives in one
                  place.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                      <polyline points="14 2 14 8 20 8" />
                      <path d="M8 13h2" />
                      <path d="M8 17h2" />
                      <path d="M14 13h2" />
                      <path d="M14 17h2" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">InBody Scan Integration</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Import your InBody body composition scans to track muscle
                  mass, body fat percentage, and more over time.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 6v6l4 2" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">AI-Powered Meal Tracking</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Log meals in seconds with AI that automatically estimates
                  calories, macros, and nutrition — no manual entry required.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M6 20h0a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h0" />
                      <path d="m12 2 4 4H8l4-4Z" />
                      <path d="M12 12v4" />
                      <path d="M12 20v2" />
                      <circle cx="12" cy="12" r="2" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Set Goals & Hit Milestones</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Set personalized weight, body composition, and nutrition goals
                  — then watch your progress unfold with visual charts and
                  milestone alerts.
                </div>
              </div>

              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <line x1="18" x2="18" y1="20" y2="10" />
                      <line x1="12" x2="12" y1="20" y2="4" />
                      <line x1="6" x2="6" y1="20" y2="14" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">Macro & Calorie Dashboard</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Get a clear daily breakdown of your calories, protein, carbs,
                  and fats with easy-to-read charts that keep you accountable.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center max-w-[700px] mx-auto">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                      <path d="m9 12 2 2 4-4" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg">All-In-One Wellness Hub</div>
                <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                  Combine meal planning, nutrition tracking, body composition
                  data, and health metrics in a single dashboard built for real
                  results.
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          <IonButton
            onClick={() => {
              next();
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Enable
          </IonButton>
          <IonButton
            onClick={async () => {
              next();
            }}
            expand="block"
            color="dark"
            fill="clear"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Maybe Later
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default ProgressTrackingIntroPage;
